import { Stack, type Theme, useMediaQuery } from '@mui/material';
import { RichText } from '@rumblefish/ui/Rumblefish23Theme';
import { StyledTextWrapper, StyledTitle } from './Solutions.styles';
import type { SolutionsProps } from './Solutions.types';

export const CaseStudySolutions = ({ solution }: SolutionsProps) => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return (
    <>
      {solution && solution.description && (
        <StyledTextWrapper>
          <StyledTitle variant="display_sm">{solution.title}</StyledTitle>
          <Stack width={'100%'}>
            {solution.description.firstParagraph && (
              <RichText
                content={solution.description.firstParagraph || ''}
                h1Variant="display_xs"
              />
            )}
            <Stack
              flex={1}
              gap={{ xs: 2, md: 3 }}
              flexDirection={{
                md: solution.description.thirdParagraph?.length
                  ? 'row'
                  : 'column',
              }}>
              {solution.description.secondParagraph && (
                <RichText
                  paragraphVariant={mdDown ? 'regular_500' : 'regular_400'}
                  h1Variant="display_xs"
                  content={solution.description.secondParagraph || ''}
                />
              )}
              {solution.description.thirdParagraph && (
                <>
                  <Stack
                    display={{ xs: 'none', md: 'flex' }}
                    sx={{
                      width: '1px',
                      padding: 0,
                      background: '#FBFCFD15',
                    }}
                  />
                  <RichText
                    paragraphVariant={mdDown ? 'regular_500' : 'regular_400'}
                    h1Variant="display_xs"
                    content={solution.description.thirdParagraph || ''}
                  />
                </>
              )}
            </Stack>
          </Stack>
        </StyledTextWrapper>
      )}
    </>
  );
};
